import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { UseFormReturn } from 'react-hook-form';
import { CustomerFormType } from './CustomerFormTypes';

interface BusinessFieldsProps {
  form: UseFormReturn<CustomerFormType>;
}

export function BusinessFields({ form }: BusinessFieldsProps) {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Business Details</h3>
      
      <div className="grid grid-cols-2 gap-4">
        <FormField
          control={form.control}
          name="business_name"
          render={({ field }) => (
            <FormItem className="col-span-2">
              <FormLabel>Business Name *</FormLabel>
              <FormControl>
                <Input {...field} value={field.value || ''} placeholder="Company name" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="vat_number"
          render={({ field }) => (
            <FormItem>
              <FormLabel>VAT Number</FormLabel>
              <FormControl>
                <Input {...field} value={field.value || ''} placeholder="10 digit VAT number" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="business_phone"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Business Phone</FormLabel>
              <FormControl>
                <Input {...field} value={field.value || ''} placeholder="Business phone number" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="business_email"
          render={({ field }) => (
            <FormItem className="col-span-2">
              <FormLabel>Business Email</FormLabel>
              <FormControl>
                <Input {...field} value={field.value || ''} type="email" placeholder="info@company.com" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}
